module.exports = "<app-wizard-select-type [selectedType]=\"selectedType\" (onselectProductType)=\"selectProductType($event)\"></app-wizard-select-type>"